import { FormattedText } from "@tm/static";
import { theme } from "@tm/utility/global";
import React from "react";
import {
  HeaderCell,
  PlanHeaderWrapper,
  PlanIcon,
  TableHeaderRow,
} from "./ComparePlans.styles";
import { IComparePlansData } from "./types";

const PLAN_NAME_STYLE: React.CSSProperties = {
  fontWeight: 900,
  fontSize: "12px",
  color: theme.blackText,
};

interface CompareTableHeaderProps {
  header: IComparePlansData["header"];
  planIds: string[];
  recommendedId: string | null;
}

const CompareTableHeader = ({
  header,
  planIds,
  recommendedId,
}: CompareTableHeaderProps) => {
  return (
    <TableHeaderRow>
      <HeaderCell $isFirst>BENEFITS</HeaderCell>
      {planIds.map((id) => {
        const item = header[id];
        if (!item) return null;

        return (
          <HeaderCell key={id} $isRecommended={id === recommendedId}>
            <PlanHeaderWrapper>
              {item.icon && <PlanIcon src={item.icon} alt="" />}
              {item.title && (
                <FormattedText value={item.title} baseStyle={PLAN_NAME_STYLE} />
              )}
            </PlanHeaderWrapper>
          </HeaderCell>
        );
      })}
    </TableHeaderRow>
  );
};

export default CompareTableHeader;
